<template>
  <div class="new-input-box">
    <input-form
      class="mb16"
      ref="formSearchRef"
      @toParentVal="submitForm"
      :inputData="inputData"
      :btnPosition1="true"
    ></input-form>
    <div class="mb12">
      <el-tooltip
        class="item"
        effect="dark"
        content="当前账号没有创建权限，请联系管理员添加。"
        placement="top"
        v-if="!permissions.includes('platform:benefit:create')"
      >
        <el-button type="primary" disabled>创建任务</el-button>
      </el-tooltip>
      <el-button
        type="primary"
        @click="
          filterPeopleCount = '';
          showIntegral = true;
        "
        v-else
        >创建任务</el-button
      >
      <!-- <el-checkbox
        v-model="form.createByMe"
        style="margin-left: 20px"
        @change="handleCreateByMe"
        >我创建的</el-checkbox
      > -->
    </div>
    <el-table
      :data="tableData"
      v-loading="talbeLoading"
      style="width: 100%; border: 1px solid #f0f0f0;"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <el-table-column prop="taskName" label="任务名称" width="200">
      </el-table-column>
      <el-table-column label="导入文件">
        <template slot-scope="scope">
          <a target="_blank" :href="scope.row.fileUrl">{{
            scope.row.fileName
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200">
      </el-table-column>
      <el-table-column label="完成时间">
        <template slot-scope="scope">
          {{
            scope.row.status == 0 || scope.row.status == 1
              ? "-"
              : scope.row.finishTime
          }}
        </template>
      </el-table-column>
      <el-table-column label="任务状态" width="200">
        <template slot-scope="scope">
          <jd-status :status="1" v-if="scope.row.status == 1">执行中</jd-status>
          <jd-status :status="2" v-else-if="scope.row.status == 0"
            >待执行</jd-status
          >
          <jd-status :status="4" v-else>执行结束</jd-status>
        </template>
      </el-table-column>
      <el-table-column label="任务结果">
        <template slot-scope="scope">
          <span
            >执行成功{{ scope.row.successNum }}条，执行失败{{
              scope.row.failNum
            }}条</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" @click="lookDetail(scope.row)"
            >变更明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="pagination-box">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="text-align: right"
        :current-page="form.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="form.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="numTotal"
      ></el-pagination>
    </div>
    <el-dialog
      title="积分变更"
      :visible.sync="showIntegral"
      width="632px"
      @close="distributionBeansCancel"
    >
      <jd-tips margin="0">
        <div>
          <div>
            注：1. 下载模板后编辑：支持输入明文pin及密文pin、积分变更量；
            <a
              target="_blank"
              href="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E5%AF%BC%E5%85%A5%E7%A7%AF%E5%88%86%E5%8F%98%E6%9B%B4%E6%A8%A1%E6%9D%BF.xlsx"
              style="color: #7B61FF"
              >点击下载模板</a
            >
            <br />
            2.会员账号(pin)需为会员；
            <br />
            3.积分变更量，正数或无正负号数值为发放、负数为扣减，且数值必须为整数；
            <br />
            4. 支持csv、xls、xlsx格式上传，大小限制在50M内；
          </div>
        </div>
      </jd-tips>
      <el-form
        :model="changeFrom"
        label-width="110px"
        class="mt16"
        ref="changeFromRef"
        :rules="changeRules"
      >
        <el-form-item label="任务名称：" prop="taskName">
          <el-input
            maxlength="30"
            show-word-limit
            v-model="changeFrom.taskName"
            class="pdr"
          ></el-input>
        </el-form-item>
        <el-form-item label="添加人群：" required>
          <el-radio-group v-model="changeFrom.selectCrowdType">
            <el-radio :label="3">导入pin</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="changeFrom.selectCrowdType == 3"
          label="选择文件："
          class="upload_item"
          prop="fileUrl"
          style="position: relative"
        >
          <el-upload
            :limit="2"
            ref="uploadFileRef"
            class="upload_box"
            :on-remove="removeFile"
            :file-list="fileList"
            action="#"
            :multiple="false"
            :show-file-list="true"
            :before-upload="beforeUpload"
            :http-request="httpUpload"
          >
            <el-button type="primary" size="small">
              点击上传文件
            </el-button>
          </el-upload>
          <div style="position: absolute; top: 0; right: 150px">
            <div>
              <i class="el-icon-loading" v-if="!uploadStatus"></i>
              <i
                class="el-icon-success"
                style="color: green"
                v-if="uploadStatus === 1"
              ></i>
              <i
                class="el-icon-error"
                style="color: red"
                v-if="uploadStatus === 2"
              ></i>
              <span v-if="!uploadStatus">上传中</span>
              <span v-if="uploadStatus === 1">上传成功</span>
              <span v-if="uploadStatus === 2">上传失败</span>
            </div>
          </div>
          <el-input
            v-model="changeFrom.fileUrl"
            style="display: none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="distributionBeansSure"
          v-loading="changeFromBtnLoading"
          >确 定</el-button
        >
        <el-button @click="distributionBeansCancel">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="变更明细" :visible.sync="detailDialogShow" width="900px">
      <input-form
        class="mb16"
        ref="detailBeansRef"
        :inputData="detailFromInfo"
        :btnPosition1="true"
        @toParentVal="detailBeansSure"
      ></input-form>
      <div class="mt12">
        <el-table
          :data="detailtableData"
          v-loading="detailtalbeLoading"
          style="width: 100%; border: 1px solid #f0f0f0;margin-top: 15px;"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <el-table-column prop="chaosPin" label="用户pin（加密）">
          </el-table-column>
          <el-table-column prop="sendNum" label="积分变更量">
          </el-table-column>
          <el-table-column prop="sendTime" label="变更时间">
          </el-table-column>
          <el-table-column label="变更状态：">
            <template slot-scope="scope">
              <div
                v-if="!scope.row.sendStatus"
                style="display: flex; align-items: center"
              >
                <jd-status :status="3">变更失败</jd-status>
                <el-tooltip :content="scope.row.failReason" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
              <jd-status :status="0" v-else>变更成功</jd-status>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            style="text-align: right"
            :current-page="detailFrom.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="detailFrom.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="detailTotal"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import jdStatus from "@/components/StatusTable/index.vue";
import jdTips from "@/components/common/jdTips.vue";
import {
  createTask,
  queryTaskPage,
  uploadFile,
  queryRecordPage,
} from "@/api/integralCenter/batchDistributionBenefits.js";
export default {
  name: "changeIntegral",
  components: {
    inputForm,
    jdStatus,
    jdTips,
  },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filterPeopleCount: "",
      filterBtnLoading: false,
      inputData: [
        {
          name: "任务昵称：",
          val: "taskName",
          placeholder: "请输入",
        },
        {
          name: "任务状态：",
          val: "status",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "待执行", id: 0 },
            { label: "执行中", id: 1 },
            { label: "执行结束", id: 2 },
          ],
        },
        {
          name: "创建时间：",
          val: "createTime",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      detailFromInfo: [
        {
          name: "用户pin：",
          val: "customerPin",
          placeholder: "请输入",
        },
        {
          name: "变更状态：",
          val: "sendStatus",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "变更成功", id: 0 },
            { label: "变更失败", id: 1 },
          ],
        },
      ],
      changeFromBtnLoading: false,
      form: {
        taskName: "",
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        sendType: 0,
        current: 1,
        size: 10,
        // createByMe: false,
      },
      fileList: [],
      tableData: [],
      talbeLoading: false,
      numTotal: 0,
      showIntegral: false,
      changeFrom: {
        selectCrowdType: 3,
        taskName: "",
        fileUrl: "",
        sendType: 0,
        fileName: "",
      },
      changeRules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        fileUrl: [{ required: true, message: "请上传文件", trigger: "change" }],
      },
      detailDialogShow: false,
      detailFrom: {
        customerPin: "",
        sendStatus: "",
        sendType: 0,
        size: 10,
        current: 1,
        id: "",
      },
      detailTotal: 0,
      detailtableData: [],
      detailtalbeLoading: false,
      uploadStatus: -1,
    };
  },

  mounted() {
    this.getBenefitList();
  },

  methods: {
    handleSizeChange(val) {
      this.form.size = val;
      this.getBenefitList();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getBenefitList();
    },
    handleSizeChange2(val) {
      this.detailFrom.pageSize = val;
      this.getRecordList();
    },
    handleCurrentChange2(val) {
      this.detailFrom.current = val;
      this.getRecordList();
    },
    // handleCreateByMe() {
    //   this.form.current = 1;
    //   this.form.size = 10;
    //   this.getBenefitList();
    // },
    getBenefitList() {
      this.talbeLoading = true;
      queryTaskPage(this.form).then((res) => {
        this.tableData = res.data.records;
        this.talbeLoading = false;
        this.numTotal = res.data.total*1;
      }).catch(() => {
        this.talbeLoading = false;
      });
    },
    replaceNullToEmptyStr(obj) {
      const newObj = {};
      for (const key in obj) {
        if (obj[key] === null) {
          newObj[key] = "";
        } else {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    },
    submitForm(data) {
      this.form = {
        ...this.form,
        current: 1,
        size: 10,
        ...this.replaceNullToEmptyStr(data),
      };
      this.form.current = 1;
      this.form.size = 10;
      this.getBenefitList();
    },

    clearTimeSendTime1() {
      this.form.xiadanstart = "";
      this.recordForm.xiadanend = "";
    },
    clearTimeSendTime2() {
      this.form.createTimeStart = "";
      this.form.createTimeEnd = "";
    },

    async distributionBeansSure() {
      try {
        await this.$refs.changeFromRef.validate();
        this.changeFromBtnLoading = true;
        let data = { ...this.changeFrom };
        data.type = 0;
        createTask(data).then((res) => {
          if (res.code == 1) {
            this.distributionBeansCancel();
            this.getBenefitList();
          } else {
            this.$message.warning(res.message);
          }
          this.changeFromBtnLoading = false;
        }).catch(() => {
          this.changeFromBtnLoading = false;
        });
      } catch (error) {
        this.changeFromBtnLoading = false;
      }
    },
    distributionBeansCancel() {
      this.showIntegral = false;
      this.changeFrom = {
        selectCrowdType: 3,
        taskName: "",
        fileUrl: "",
        fileName: "",
        sendType: 0,
      };
      this.uploadStatus = -1;
      if (this.$refs.uploadFileRef) {
        this.$refs.uploadFileRef.clearFiles();
        this.$refs.changeFromRef.resetFields();
      }
    },
    getRecordList() {
      this.detailtalbeLoading = true;
      queryRecordPage(this.detailFrom).then((res) => {
        this.detailtalbeLoading = false;
        this.detailtableData = res.data.records;
        this.detailTotal = +res.data.total;
      });
    },
    lookDetail(row) {
      this.detailFrom.id = row.id;
      this.detailFrom = {
        ...this.detailFrom,
        customerPin: "",
        sendStatus: "",
        sendType: 0,
        size: 10,
        current: 1,
      };
      this.detailDialogShow = true;
      this.getRecordList();
    },
    detailBeansSure(data) {
      this.detailFrom = {
        ...this.detailFrom,
        ...this.replaceNullToEmptyStr(data),
        current: 1, // 重置页码
        size: 10, // 重置每页条数
      };
      this.getRecordList();
    },
    handlePage2({ pageNum, pageSize }) {
      this.detailFrom.current = pageNum;
      this.detailFrom.size = pageSize;
      this.getRecordList();
    },
    closeIntegralDialog() {
      this.showIntegral = false;
    },
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > 50) {
        this.$message.warning("文件不得超过50M");
        return false;
      }
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    removeFile(file, fileList) {
      console.log(file, fileList);
      this.changeFrom.fileUrl = "";
      this.changeFrom.fileName = "";
      this.uploadStatus = -1;
      this.fileList = [];
    },
    httpUpload({ file }) {
      this.removeFile();
      let formData = new FormData();
      formData.append("file", file);
      this.uploadStatus = 0;
      console.log(formData);
      uploadFile(formData, 5).then((res) => {
        if (res.code == 1) {
          this.uploadStatus = 1;
          this.changeFrom.fileUrl = res.data.fileUrl;
          this.changeFrom.fileName = file.name;
          this.fileList = [{ name: file.name, url: res.data.fileUrl }];
        } else {
          this.uploadStatus = 2;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
::v-deep .el-input .el-input__count .el-input__count-inner {
  background-color: #f5f5f7;
}
.dialog-footer {
  text-align: right;
}
.form_tip {
  background-color: #f4f4f5;
  padding: 8px 12px;
  font-size: 12px;
}
::v-deep .upload_box .el-upload {
  width: 100px;
  display: flex;
  align-items: center;
}
::v-deep .upload_item .el-form-item__content {
  position: relative;
  display: flex;
}

::v-deep .pdr .el-input__inner {
  padding-right: 50px;
}
.mb12 {
  margin-bottom: 12px;
}
.mb16 {
  margin-bottom: 16px;
}
.mt16 {
  margin-top: 16px;
}
</style>
